import { fetchData, setHeaderOptions } from "./apiHelpers";
import { ApiEndpoints } from "./apiEndpoints";

export type ProviderPatientRequestRow = {
  id: string;
  provider_user_id: string;
  patient_user_id: string;
  status: "pending" | "accepted" | "declined" | "expired";
  message: string | null;
  created_at: string;
  responded_at: string | null;
  updated_at: string;
};

export async function getIncomingProviderPatientRequests(): Promise<
  ProviderPatientRequestRow[]
> {
  const slug = `${ApiEndpoints.providerPatientRequests}/incoming`;
  const options = await setHeaderOptions({ method: "GET" });
  return fetchData<ProviderPatientRequestRow[]>(slug, options);
}

export async function respondProviderPatientRequest(
  id: string,
  action: "accept" | "decline",
  makePrimary = false
): Promise<ProviderPatientRequestRow> {
  const slug = `${ApiEndpoints.providerPatientRequests}/${id}/respond`;
  const options = await setHeaderOptions({
    method: "POST",
    body: { action, makePrimary },
  });
  return fetchData<ProviderPatientRequestRow>(slug, options);
}
